import { dynamicLoader } from '~/utils';

export const RolesPage = dynamicLoader({
  name: 'RolesPage',
  importFunc: () => import('./roles'),
});